export default __webpack_public_path__ + "static/media/arrow-right.d9070c9e.svg";